import { useContextHook } from "../../Context/ContextOPen";
import { Col, Container, Row } from "../../Tools/Grid-system";
import logo from "../../images/Artboard3.png";
import ContactIcons from "../ContactIcons/ContactIcons";

const AboutUs = () => {
  const { swiperIndex, content, direction } = useContextHook();
  return (
    <div style={{ direction: direction }}>
      <Container>
        <Row className="items-center h-[93dvh] max-lg:h-full">
          <Col md={5} className="flex justify-center items-center ">
            <img
              src={logo}
              alt=""
              className="max-md:w-1/2 "
            />
          </Col>
          <Col md={7} className={`  ${swiperIndex === 1 ? "hero" : ""}`}>
            <div className="">
              <h1 className="text-5xl max-md:text-4xl font-bold mb-5 logo first-letter:text-Main">
                {content.AboutUs}
              </h1>
              <div className="font-bold text-4xl max-sm:text-2xl text-white logo mb-5">
                {content.Company}
              </div>
              <p className="sm: text-lg leading-8">
                {content.AboutUsDescription}
              </p>
              <div className=" my-7">
                <ContactIcons index={1} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutUs;
